export const QueryKeys = {
  timezones: () => ["timezones"],
  languages: () => ["languages"],
  countries: () => ["countries"],
  finishRegistration: () => ["finishRegistration"],
};
